import { render, staticRenderFns } from "./ChildrensVBS.vue?vue&type=template&id=034f6ced&"
import script from "./ChildrensVBS.vue?vue&type=script&lang=js&"
export * from "./ChildrensVBS.vue?vue&type=script&lang=js&"
import style0 from "./ChildrensVBS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports